import { useEffect, useMemo, useState } from 'react';

const useUniqueHashEffect = (
  effect: () => unknown,
  uniqueObject: Record<string, Maybe<unknown>>,
) => {
  const [hash, setHash] = useState('');
  const newHash = useMemo(() => JSON.stringify(uniqueObject), [uniqueObject]);

  useEffect(() => {
    if (newHash !== hash) {
      setHash(newHash);
      effect();
    }
  }, [effect, hash, newHash]);
};

export default useUniqueHashEffect;
